import { type Cell } from "@tanstack/react-table";
import { type PropsWithChildren } from "react";

import { type BaseObject } from "../../../evidence/base";
import { cn } from "../../../utils/cn";
import { createBaseColumn } from "./base-column";
import { type ActionsTableColumnOptions } from "./types";

const ACTIONS_COLUMN_ID = "actions";

export function isActionColumnCell<TData extends BaseObject = BaseObject>(
  cell: Cell<TData, any>,
) {
  return cell.column.id === ACTIONS_COLUMN_ID;
}

export function ActionsCellLayout({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={cn("flex items-center", className)}
      // When clicking an action, don't navigate to the row
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
}

export function createActionsColumn<T extends BaseObject>({
  actions,
  ...options
}: ActionsTableColumnOptions<T>) {
  return createBaseColumn<T>({
    ...options,
    type: "ACTIONS",

    id: ACTIONS_COLUMN_ID,

    cell: ({ row }) => actions(row.original),

    enableFilter: false,
    enableActions: false,
    enableHiding: false,
    enableSorting: false,
    enableResizing: false,

    className: cn("py-0 flex items-center", options.className),
  });
}
